import React, { useState, useEffect, useContext, useRef  } from "react";
import { connect } from "react-redux";
import { LayoutContext } from "../../layouts/UserLayout";
import { Card, CardBody, Row, FormGroup, Label, Button } from 'reactstrap';
import Icon from 'react-icons-kit';
import { eye } from 'react-icons-kit/feather/eye';
import { eyeOff } from 'react-icons-kit/feather/eyeOff';
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import FormLoader from "../../components/loader/FormLoader";
import { Colxx,Separator } from "../../components/common/CustomBootstrap";
import IntlMessages from "../../utils/IntlMessages";
import { passwordRegex } from "../../constants/defaultValues";
import { getChangePassword } from "../../redux/auth/action";
import { hasPermission } from "../../utils/UserDetails";


const ChangePassword = ({ match, getChangePassword, changePassword, menuId }) => {
    const { setPageTitle } = useContext(LayoutContext);


  const initialValues = {
    oldPassword: "",
    newPassword: "",
    confirmpassword: "",
  };

  const modalData = {
    isSuccess: 0,
    header: "Password Does not match",
  };

  const formikref = useRef();
  const [show, setShow] = useState(false);
  const [oldPasswordType, setOldPasswordType] = useState('password')
  const [oldPasswordIcon, setOldPasswordIcon] = useState(eyeOff)
  const [type, setType] = useState('password')
  const [icon, setIcon] = useState(eyeOff)
  const [passwordType, setPasswordType] = useState('password')
  const [passwordIcon, setPasswordIcon] = useState(eyeOff)
  const [notificationData, setNotificationData] = useState(modalData);

                useEffect(() => {
    setPageTitle(<IntlMessages id={menuId} />);
      
      return () => setPageTitle(""); 
    }, [setPageTitle]);

  useEffect(() => {
    setShow(false)
    changePassword=false;
    setNotificationData(modalData)
  }, [])

  useEffect(() => {
   
    if (changePassword) {
     
      if (changePassword.status) {
        setNotificationData({
          isSuccess: 1,
          header: changePassword?.message ? (
            changePassword?.message
          ) : (
            <IntlMessages id="changepassword.change-password-popup" />
          ),
        });
      } else {
        setNotificationData({
          isSuccess: 0,
          header: changePassword?.message ? (
            changePassword?.message
          ) : (
            <IntlMessages id="changepassword.try-popup" />
          ),
        });
      }
     setShow(true);
    }
  }, [changePassword])

  const changePwdSchema = Yup.object().shape({
    oldPassword: Yup.string()
    .min(8, 'The old password must be at least 8 characters.')
    .required(
      <IntlMessages id="changepassword.old-password-error" />
    ),
    newPassword: Yup.string()
      .required(<IntlMessages id="changepassword.new-password-error" />)
      .min(8, 'The New password must be at least 8 characters.')
      .matches(passwordRegex.atLeastOne, passwordRegex.atleastoneMessage)
      .matches(passwordRegex.consective, passwordRegex.consectiveMessage),
    confirmpassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], 'Password does not match')
      .required(<IntlMessages id="register.validation12" />),
    
    
  });

  const handleToggleOldPassword = () => {
    if (oldPasswordType === 'password') {
      setOldPasswordIcon(eye);
      setOldPasswordType('text');
    }
    else {
      setOldPasswordIcon(eyeOff);
      setOldPasswordType('password');
    }
  }

  const handleToggle = () => {
    if (type === 'password') {
      setIcon(eye);
      setType('text');
    }
    else {
      setIcon(eyeOff);
      setType('password');
    }
  }

  const handleTogglePassword = () => {
    if (passwordType === 'password') {
      setPasswordIcon(eye);
      setPasswordType('text');
    }
    else {
      setPasswordIcon(eyeOff);
      setPasswordType('password');
    }
  }

  const toggleModal = () => {
    setShow(false);
  }

  const handleSubmit = (formData, setSubmitting, resetForm) => {
    let data = {
      oldPassword: formData?.oldPassword,
      newPassword: formData?.newPassword,
    };
     getChangePassword(data, setSubmitting, resetForm);
  }


  return (
    <>
      <Row>
        <Colxx xxs="12" className="mb-4 mt-4">
          <Card className='change-password col-md-4 m-auto'>
            <CardBody>
              <Formik
                initialValues={initialValues}
                validationSchema={changePwdSchema}
                enableReinitialize={true}
                onSubmit={(formData, { setSubmitting, resetForm }) => {
                  handleSubmit(formData, setSubmitting, resetForm)
                }}
                ref={formikref}
              >
                {({
                  errors,
                  touched,
                  isSubmitting,
                }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <FormGroup className="form-group has-float-label no-margin">
                      <Label>
                        <IntlMessages id='changepassword.old-password' />
                      </Label>
                      <Field name="oldPassword" className="form-control" type={oldPasswordType} />
                      <span onClick={handleToggleOldPassword} className='icon-config-password'><Icon icon={oldPasswordIcon} /></span>
                    </FormGroup>
                    <span className='error-message'>
                      {errors.oldPassword && touched.oldPassword ? errors.oldPassword : null}
                    </span>
                    <FormGroup className="form-group has-float-label mt-2 no-margin">
                      <Label>
                        <IntlMessages id='changepassword.new-password' />
                      </Label>
                      <Field name="newPassword" className="form-control" type={type} />
                      <span onClick={handleToggle} className='icon-config-password'><Icon icon={icon} /></span>
                    </FormGroup>
                    <span className='error-message'>
                      {errors.newPassword && touched.newPassword ?errors.newPassword : null}
                    </span>

                    <FormGroup className="form-group has-float-label mt-2 no-margin">
                      <Label>
                        <IntlMessages id='changepassword.confirm-password' />
                      </Label>
                      <Field name="confirmpassword" className="form-control" type={passwordType} />
                      <span onClick={handleTogglePassword} className='icon-config-password'><Icon icon={passwordIcon} /></span>
                    </FormGroup>
                    <span className='error-message'>
                      {errors.confirmpassword && touched.confirmpassword ? errors.confirmpassword : null}
                    </span>
                                                  {hasPermission(menuId, 'canWrite') && (
                    <Row className='d-block text-right mx-0 mt-3'>
                      <Button outline color="primary" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? <FormLoader /> : <IntlMessages id='changepassword.update' />}
                      </Button>
                    </Row>
                                                  )}
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
      {/* <NotificationModal modalOpen={show} toggleModal={toggleModal} modalData={notificationData} /> */}
    </>
  )
}

const mapStateToProps = state => ({
  changePassword: state.auth.changePassword,
})

export default connect(mapStateToProps, { getChangePassword })(ChangePassword);
